import {
   Document,
   Page,
   Text,
   View,
   StyleSheet,
   PDFViewer,
   Font,
   Image,
} from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Create styles

// Font.register({
//   family: 'Nunito',
//   src: `https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0e.ttf`,
// });

const SummaryPDFViewer = () => {
   const { state } = useLocation();
   const [selectedNodes, setSelectedNodes]: any = useState([]);
   const [patientInfo, setPatientInfo]: any = useState({ name: "", age: "" });
   const navigate = useNavigate();

   useEffect(() => {
      console.log({ state });
      if (
         state &&
         state.previousScreen === "diagnose" &&
         state.selectedNodes &&
         state.patientInfo
      ) {
         setSelectedNodes(state.selectedNodes);
         setPatientInfo(state.patientInfo);
      } else {
         //  return console.log("here");
         navigate("/");
      }
   }, []);
   //    selectedNodes = [{ data: { label: "1", desc: "desc" } }];
   return (
      <PDFViewer style={styles.viewer}>
         {/* Start of the document*/}
         <Document>
            {/*render a single page*/}
            <Page size="A4" style={styles.page}>
               <View style={styles.header}>
                  <Image
                     source={require("../assests/login-logo.png")}
                     style={{ height: 30, marginRight: 10 }}
                  />
                  <Text
                     style={{
                        color: "black",
                        fontSize: 20,
                        fontWeight: "bold",
                     }}
                  >
                     MediFlow
                  </Text>
               </View>
               <View
                  style={{
                     marginTop: 30,
                  }}
               >
                  <Text
                     style={{
                        fontSize: 14,
                        color: "#449183",
                     }}
                  >
                     Patient's Info
                  </Text>
                  <Text
                     style={{
                        fontSize: 12,
                        marginTop: 10,
                        color: "#161616",
                        marginLeft: 10,
                     }}
                  >
                     Name: {patientInfo.name}
                  </Text>
                  <Text
                     style={{
                        fontSize: 12,
                        marginTop: 5,
                        color: "#161616",
                        marginLeft: 10,
                     }}
                  >
                     Age: {patientInfo.age}
                  </Text>
                  <Text
                     style={{
                        fontSize: 12,
                        marginTop: 5,
                        color: "#161616",
                        marginLeft: 10,
                     }}
                  >
                     City: {patientInfo.city}
                  </Text>
               </View>
               <View
                  style={{
                     marginTop: 30,
                  }}
               >
                  <Text
                     style={{
                        fontSize: 14,
                        color: "#449183",
                     }}
                  >
                     Summary
                  </Text>
                  <View
                     style={{
                        paddingHorizontal: 10,
                     }}
                  >
                     {/* <View
                        style={{
                           display: "flex",
                           flexDirection: "row",
                           marginTop: 20,
                           //  justifyContent: "space-between",
                           //  paddingRight: 7,
                        }}
                     >
                        <View
                           style={{
                              backgroundColor: "#449183",
                              borderRadius: "50%",
                              width: 10,
                              height: 10,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginTop: 3,
                           }}
                        />
                        <View
                           style={{
                              display: "flex",
                              // flex: 1,
                              marginLeft: "10px",
                              flexDirection: "column",
                           }}
                        >
                           {selectedNodes &&
                              selectedNodes[0] &&
                              selectedNodes[0].data.label
                                 .split("\\n")
                                 .map((ele: string, index: any) => (
                                    <Text
                                       style={{
                                          fontSize: 14,
                                          //  fontWeight: "600",
                                          //   lineHeight: 18,
                                          marginTop: 5,
                                          color: "#161616",
                                       }}
                                       key={index}
                                    >
                                       {ele}
                                    </Text>
                                 ))}
                        </View>
                     </View>
                     <View
                        style={{
                           padding: 10,
                        }}
                     >
                        <Text
                           style={{
                              fontSize: 14,
                              // fontFamily: "Nunito", sans-serif;
                              lineHeight: 16,
                              color: "#161616",
                              marginLeft: 10,
                           }}
                        >
                           {selectedNodes[0].data.description}
                        </Text>
                     </View> */}
                     {selectedNodes.map((data: any, index: number) => (
                        <View key={index}>
                           <View
                              break
                              style={{
                                 display: "flex",
                                 flexDirection: "row",
                                 marginTop: 20,
                                 //  justifyContent: "space-between",
                                 //  paddingRight: 7,
                              }}
                              //  onClick={() => {
                              //     //   setExpanded(
                              //     //      expanded === data.id ? false : data.id
                              //     //   );
                              //  }}
                           >
                              <View
                                 style={{
                                    backgroundColor: "#449183",
                                    borderRadius: "50%",
                                    width: 10,
                                    height: 10,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 3,
                                 }}
                              ></View>
                              <View
                                 style={{
                                    display: "flex",
                                    // flex: 1,
                                    marginLeft: "10px",
                                    flexDirection: "column",
                                 }}
                              >
                                 {data.data.label
                                    .split("\\n")
                                    .map((ele: string, index: any) => (
                                       <Text
                                          style={{
                                             fontSize: 14,
                                             //  fontWeight: "600",
                                             //    lineHeight: 18,
                                             color: "#161616",
                                             marginTop: index !== 0 ? 5 : 0,
                                          }}
                                          key={index}
                                       >
                                          {ele}
                                       </Text>
                                    ))}
                              </View>
                           </View>
                           <View style={{ padding: 10 }}>
                           {data.data.description
                                    .split("\\n")
                                    .map((ele: string, index: any) => (
                              <Text
                                 style={{
                                    fontSize: 14,
                                    // fontFamily: "Nunito", sans-serif;
                                    // lineHeight: 16,
                                    color: "#7a7a7a",
                                    marginLeft: 10,
                                 }}
                                 key={index}
                              >
                                 {ele}
                              </Text>
                                    ))}
                           </View>
                        </View>
                     ))}
                  </View>
               </View>
            </Page>
         </Document>
      </PDFViewer>
   );
};
const styles = StyleSheet.create({
   page: {
      backgroundColor: "#fff",
      color: "white",
      paddingHorizontal: 20,
      paddingVertical: 30,
   },
   viewer: {
      width: window.innerWidth, //the pdf viewer will take up all of the width and height
      height: window.innerHeight,
   },
   header: {
      marginTop: 0,
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
   },
});
export default SummaryPDFViewer;
